var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.cycleTheme}},[_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.currentThemeIcon)+" "+_vm._s(_vm.currentThemeLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }